import { render } from "./newblog.vue?vue&type=template&id=6a066e9c"
import script from "./newblog.vue?vue&type=script&lang=js"
export * from "./newblog.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__